import { 
    CreateLocationDto, 
    DeleteLocationDto,
    EditLocationDto,
    GetLocationDto, 
    LocationApiFp,
    LocationControllerGet200Response,
    MessageResponseDto, 
} from "@api/api";
import { apiConfig } from "@factory/query/config";
import { QueryKey } from "@factory/query/query-key.enum";

export type GetResponseLocationModel = LocationControllerGet200Response;
export type GetLocationModel = GetLocationDto;
export type MutateResponseLocationModel = MessageResponseDto;
export type CreateLocationModel = CreateLocationDto;
export type UpdateLocationModel = EditLocationDto;
export type DeleteLocationModel = DeleteLocationDto;

export const apiLocationFp = LocationApiFp(apiConfig);
export const getLocationController = apiLocationFp.locationControllerGet;
export const createLocationController = apiLocationFp.locationControllerCreate;
export const updateLocationController = apiLocationFp.locationControllerEdit;
export const deleteLocationController = apiLocationFp.locationControllerDelete;

export const QueryKeyLocation = QueryKey.Location;